// extracted by mini-css-extract-plugin
export default {"main":"main_main__citOI","head":"main_head__D3nLE","items":"main_items__8BS1l"};